var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"global"},[_c('extend'),_c('extend-date')],1),_c('router-view'),_c('meetDialog',{attrs:{"meetDialogInfo":_vm.meetDialogInfo},on:{"close":_vm.dialogCloseHandle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }